import { register } from "@rill/loader";
import moment from "moment";

// Powers the Log view's Habits card — resolved habit checklist per day
// (coach/org template + DailyStat.accountabilities merge), same computation
// the athlete's own calendar Log uses. See msb-api/lib/api/habit-logs.js.
register(
  {
    name: "habitLogs",
    meta: ["no-bust", "daily-stats", "thread"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete, start, end }) => {
    const res = await api("habit-logs", {
      query: {
        proxyAthlete,
        startDate: moment(start).format("YYYY-MM-DD"),
        endDate: moment(end).format("YYYY-MM-DD"),
      },
    });
    const { habitLogs } = await res.json();
    return habitLogs;
  }
);
